import DeleteConfirmationModal from './DeleteConfirmationModal';

export default DeleteConfirmationModal;
